import { select } from '@angular-redux/store';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of, Subscription } from 'rxjs';
import { catchError, first, tap } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
  isOldWrong = false;
  isNewDifferent = false;
  isChanged = false;

  currentLang = 'it';

  subscriptions: Subscription[] = [];

  loading = false;

  @select(['logged', 'logged'])
  userLogged$: Observable<any>;
  userId: number;

  passwords = this.fb.group({
    oldPassword: this.fb.control('', Validators.required),
    newPassword: this.fb.control('', Validators.required),
    newPasswordRepeated: this.fb.control('', Validators.required)
  });

  get oldPassword() {
    return this.passwords.get('oldPassword').value;
  }
  get newPassword() {
    return this.passwords.get('newPassword').value;
  }
  get newPasswordRepeated() {
    return this.passwords.get('newPasswordRepeated').value;
  }

  constructor(private titleService: Title,
              private fb: FormBuilder,
              private apiservice: ApiService,
              private translate: TranslateService) {
    this.translate.setDefaultLang('it');
    if (this.translate.currentLang) {
      this.currentLang = this.translate.currentLang;
      this.translate.use(this.currentLang);
    } else {
      this.translate.use('it');
      this.currentLang = this.translate.currentLang;
    }
    this.translate.onLangChange.subscribe(() => {
      this.currentLang = this.translate.currentLang;
    });
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.userLogged$.subscribe( user => {
        this.userId = user.id;
      }),
      this.translate.get('breadcrumb.admin_pwd').subscribe((res: string) => {
        this.titleService.setTitle(res + ' - PRIMIS');
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  changePwd() {
    this.resetMessages();
    this.passwords.markAllAsTouched();
    this.isNewDifferent = this.newPassword !== this.newPasswordRepeated;
    if (this.passwords.valid && !this.isNewDifferent) {
      this.loading = true;
      this.apiservice.changePwd(
        this.userId, this.oldPassword, this.newPassword
      ).pipe(
        first(),
        tap(() => {
          this.loading = false;
          this.isChanged = true;
        }),
        catchError((err) => {
          this.loading = false;
          this.isOldWrong = true;
          return of(err);
        })
      ).subscribe();
    }
  }

  resetMessages() {
    this.isOldWrong = false;
    this.isNewDifferent = false;
    this.isChanged = false;
  }
}
